// src/pages/PhoneBook.js
import React from "react";
import { Container, Row, Col, Alert } from "react-bootstrap";
import Header from "./Header";
import Footer from "./Footer";
import SideMenu from "./SideMenu";
import MemberMenu from "./MemberMenu";
import AdminMenu from "./AdminMenu";
import Logout from "./Logout";
import { useAuth } from "./Home1"; // Corrected Path

const LoadVoucher = () => {
  const { user } = useAuth();
  const isAdmin = user?.id === "71";

  React.useEffect(() => {
    document.title = "Load Voucher - beaconSMS";
  }, []);

  return (
    <>
      <Container>
        <Header user={user} />

        <Row className='mt-3 px-md-3'>
          {/* Side Menu Column */}
          <Col md='3' className='mb-3 mb-md-0'>
            <Logout Menu='Login Menu' user={user?.username} />
            <SideMenu Menu="Member's Menu" menuu={MemberMenu} />
            {isAdmin && <SideMenu Menu="Admin's Menu" menuu={AdminMenu} />}
          </Col>

          {/* Main Content Area Column */}
          <Col md='9' className='mt-3 mt-md-0'>
            {/* --- Sticky Wrapper for Header and Alert --- */}
            <div
              className='sticky-top pt-2 pb-2' // pt-2/pb-2 add some padding inside the sticky area
              style={{
                top: 0, // Stick right at the top of the viewport (adjust if you have a fixed navbar above this)
                zIndex: 1010, // High z-index to stay on top
                backgroundColor: "var(--bs-body-bg, white)", // Use Bootstrap's body background color variable or fallback to white
              }}
            >
              {/* Phone Book Header */}
              <h1 className='h3 mb-3 text-center fw-bold text-primary'>
                {" "}
                {/* Reduced bottom margin slightly */}
                Load Voucher
              </h1>

              {/* "Coming Soon" Alert Row (already centered) */}
              <Row className='justify-content-center'>
                {" "}
                {/* Removed mt-4, handled by wrapper padding */}
                <Col md={10} lg={8}>
                  <Alert variant='info' className='text-center shadow-sm mb-0'>
                    {" "}
                    {/* Removed extra bottom margin */}
                    <Alert.Heading as='h5'>Feature Coming Soon!</Alert.Heading>
                    <hr />
                    <p className='mb-0'>
                      This feature is currently under development and will be
                      accessible soon. Thank you for your patience.
                    </p>
                  </Alert>
                </Col>
              </Row>
            </div>
            {/* --- End Sticky Wrapper --- */}
          </Col>
        </Row>
        <Footer />
      </Container>
    </>
  );
};

export default LoadVoucher;
